// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"439":"5d9336b2","924":"f3bdf3f7"}[chunkId] + ".chunk.css";
};